const Tooltip = () => ({
    show: false,

    init() {

    },
    text: {
        ['@mouseover']() {
            this.show = true;
        },
        ['@mouseleave']() {
            this.show = false;
        }
    }
});

export default Tooltip;